"use client";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PublicCloudTabs from "@/components/pageTabs/publicCloudTabs";
import HeroComponent from "./components/hero";
import IntroComponent from "./components/intro";
import UseCasesComponent from "./components/useCases";
import Comparison from "./components/comparison";
import FaqComponent from "./components/faq";
import ReasonComp from "./components/reason";
import BuyCta from "./components/pricingConclusion";
import BareMetalServerCard from "./components/pricingCard";

const BareMetalPage = () => {
  return (
    <Box>
      <HeroComponent />
      <PageLayout showCustomers showContactForm spacing={20}>
        <PublicCloudTabs />
        <IntroComponent />
        <ReasonComp />
        <BareMetalServerCard />
        <BuyCta />
        <UseCasesComponent />
        <Comparison />
        <FaqComponent />
      </PageLayout>
    </Box>
  );
};

export default BareMetalPage;
